import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import "./FlagDropdown.css";
import { storeMenuData } from "../../Data/StoreData";

type LanguageOption = {
  label: string;
  value: string;
  flag: string;
};

const { AmericaFlag, IndiaFlag } = storeMenuData;

const languageOptions: LanguageOption[] = [
  { label: "English", value: "en", flag: AmericaFlag },
  { label: "தமிழ்", value: "ta", flag: IndiaFlag },
  { label: "हिंदी", value: "hi", flag: IndiaFlag },
];

const FlagDropdown: React.FC = () => {
  const { i18n } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(() => {
    const storedLang = localStorage.getItem("i18nextLng") || "en";
    return languageOptions.find((opt) => opt.value === storedLang) || languageOptions[0];
  });

  const toggleDropdown = () => setIsOpen(!isOpen);

  const handleSelect = (option: LanguageOption) => {
    setSelected(option);
    i18n.changeLanguage(option.value);  // 🔄 Change language
    setIsOpen(false);
  };

  return (
    <div className="flag-dropdown">
      <div className="dropdown-selected" onClick={toggleDropdown}>
        <img src={selected.flag} alt={selected.label} />
        <span>{selected.label}</span>
        <span className="arrow">{isOpen ? "▲" : "▼"}</span>
      </div>

      {isOpen && (
        <div className="dropdown-options">
          {languageOptions.map((option) => (
            <div
              key={option.value}
              className={`dropdown-option ${selected.value === option.value ? "active" : ""}`}
              onClick={() => handleSelect(option)}
            >
              <img src={option.flag} alt={option.label} />
              <span>{option.label}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default FlagDropdown;
